import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import classes from "./Auth.module.css";
import image from "../../assets/images/logo.png";

class AuthAdmin extends Component {
  state = {
    isLogin: false,
    name: "",
    photo: "",
  };

  //   handleLogin = (loginWith) => {
  //     this.props.login(loginWith);
  //   };

  // componentDidMount = () => {
  //   this.props.checkAuthState();
  // };
  render() {
    return (
      <div className={classes.Modal}>
        <img
          src={image}
          style={{ width: "20rem", marginBottom: "1rem", marginTop: "7%" }}
        />
        <div>
          <button
            className={`${classes.loginBtn} ${classes.loginBtngoogle}`}
            // className="loginBtn loginBtngoogle"
            onClick={this.props.login}
          >
            Login with Google
          </button>
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    login: () => dispatch(actions.auth()),
    checkAuthState: () => dispatch(actions.checkAuthState()),
  };
};

export default connect(null, mapDispatchToProps)(AuthAdmin);
